const US_PHONE_FORMAT = /^(1|)?(\d{3})(\d{3})(\d{4})$/;

export const phoneValidation = (phone) => {
  let cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(US_PHONE_FORMAT);
  const isMatched = US_PHONE_FORMAT.test(cleaned);
  if (isMatched) {
    const formattedPhone = ["(", match[2], ") ", match[3], "-", match[4]].join(
      ""
    );

    return formattedPhone;
  } else {
    return false;
  }
};

export const inputFormat = (e) => {
  let { value } = e.target;
  let tempVal = "";
  const input = value.replace(/\D/g, "").substring(0, 10);
  const formattedVal = "+1" + input;
  const zip = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);
  if (input.length > 6) {
    tempVal = `(${zip}) ${middle}-${last}`;
  } else if (input.length > 3) {
    tempVal = `(${zip}) ${middle}`;
  } else if (input.length > 0) {
    tempVal = `(${zip}`;
  }
  return tempVal;
};
